import { SET_ACADEMIC_SECTIONS } from "../actions/constants";
import { SET_ACADEMIC_SECTION } from "../actions/constants";
import {createReducer} from "../../../_common/common.ts";

export const academicSections = createReducer(null, {
    [SET_ACADEMIC_SECTIONS]: (state, payload)=> payload
});

export const academicSection = createReducer(null, {
    [SET_ACADEMIC_SECTION]: (state, payload)=> payload
});

